import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Observable } from 'rxjs';
import { IIndexOrder } from 'src/app/shared/Models/IOrder';
import { IUser } from 'src/app/shared/Models/IUser';
import { IBaseItem } from 'src/app/shared/Models/TopCollectionProduct';
import { HomeService } from 'src/app/shared/services/home.service';
import { environment } from 'src/environments/environment';
import { Order } from '../../../shared/classes/order';
import { OrderService } from '../../../shared/services/order.service';
import { ProductService } from '../../../shared/services/product.service';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss']
})
export class SuccessComponent implements OnInit{

  order$: Observable<IIndexOrder>

  public orderDetails : Order = {};
  totalAmount=0;
  subTotal=0;
  couponAmount=0;
  totalPrice = 0;
  isRepeatReques = true;
  disabledCheckOut = true;
  isWholeSaleAccount=false;
  taxiAmount =0;

  reward=0;
  constructor(public productService: ProductService,
    private _homeService: HomeService,
    private _orderService: OrderService) { 
      var user:IUser = JSON.parse(localStorage.getItem('user'));
      this.isWholeSaleAccount = user.isWholeSaleAccount;
    }

  ngOnInit(): void {	
    // this.orderService.checkoutItems.subscribe(response => this.orderDetails = response);
    this.order$ = this._orderService.getOrder$;






    this.order$.subscribe((order:IIndexOrder)=>{
      order.orderItems.forEach(item=>{
        item.productImage = `${environment.imageApi}/Resources/Images/Product/${item.productImage}`;
        item.unitTotal = item.unitPrice * item.quantity;
      })

      this.couponAmount = order.couponAmount;
      this.reward = order.reward;
      this.subTotal = order.orderItems.reduce((sum,current)=>sum+current.quantity*current.unitPrice,0);
      var amountOfTaxi = this.onTaxiCalculation(order);

      this.totalAmount =this.subTotal+amountOfTaxi-(order.reward+ order.couponAmount);

    })
  }



  public onDisplayImage = (serverPath: string) => {
    let imageApi =environment.imageApi;
  var result = `${imageApi}/${serverPath}`;
  
  return result;
}




onTaxiAmount(order: IIndexOrder): number
{
  var result = this.onTaxiCalculation(order);
  return result;
}

onTaxiCalculation(order:IIndexOrder)
{
  var amount =0;
  if(order.orderTrack ==1)
  {
    if(order.orderTrackPayment ==1)
    {
      //orderTrackPlace ==1 => no sent
      //orderTrackPlace ==2 => Inside Hawler
      //orderTrackPlace ==3 => OutSide Hawler

      if(order.orderTrackPlace ==2)
      {
        amount= this.taxiAmount = 1.99;
      } else if(order.orderTrackPlace ==3)
      {
        amount =  this.taxiAmount = 2.99
      }
    }
  }
   return amount;
}





}
